import { render, staticRenderFns } from "./params.vue?vue&type=template&id=66b79622"
import script from "./params.vue?vue&type=script&lang=js"
export * from "./params.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports